import React, { useState, useContext, useEffect } from "react";
import { StoreContext, StoreProvider } from "./Store/Provider";
import Navigation from "./Route/Navigation";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import "./index.css";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { useNavigate } from "react-router-dom";
import { rgbToHex } from "@material-ui/core";

function App() {
  const history = useNavigate();
  const context = useContext(StoreContext);
  const [tourState, setTourState] = useState({
    steps: [
      {
        title: "Home",
        target: ".TourfirstStep",
        content: "Connect to your resources or website",
        placement: "right",
        disableBeacon: true,
      },
      {
        title: "Request For Quotes",
        target: ".ToursecondStep",
        content: "Your client can Inquire or request for quotes!",
        placement: "right",
        screen: "/Home/RequestQuote",
        disableBeacon: true,
      },
      {
        target: ".TourthirdStep",
        content:
          "Your Client can inquire about shipment (Discover, Plan & Submit your ideal shipment inquiry). Note: This feature will help you discover available routes, dates, and shipments",
        disableBeacon: true,
      },
      {
        target: ".TourfourthStep",
        content:
          "Your clients can submit quotations requests based on sailing schedules (Submit quotation requests based on sailing schedules)",
        disableBeacon: true,
      },
      {
        title: "Your shipments",
        target: ".TourfifthStep",
        content:
          "View all your shipment details here! May it be sea, air, train, or road! (Click here for all your shipment details Hint: Available by Sea, Air, Train, or Road transport)",
        screen: "/Home/Shipments",
        placement: "right",
        disableBeacon: true,
      },
      {
        target: ".ToursixthStep",
        content:
          "All Pre-Loaded Shipment (Click here to filter by pre-loaded shipments)",
        disableBeacon: true,
      },
      {
        target: ".TourseventhStep",
        content:
          "Customs search by PO Number, MBL Number, Carrier etc. (Search for specific shipment. Hint: You can search by PO Number,MBL Number, Carrier etc).",
        disableBeacon: true,
      },
      {
        target: ".ToureigthStep",
        content:
          "Clients can select the shipment ID and view all information (Click any shipment to view more details)",
        disableBeacon: true,
      },
      {
        target: ".TourninethStep",
        content:
          "All shipment that are in transit (Click here to filter by shipments in transit)",
        disableBeacon: true,
      },
      {
        target: ".TourtenthStep",
        content:
          "Clients can turn on Notifications to receive an E-Mail alert on a specific shipment (Toggle to receive email alerts/updates for this specific shipment) ",
        disableBeacon: true,
      },
      {
        target: ".ToureleventhStep",
        content:
          "Clients can E-Mail on a specific shipment (Click to make an inquiry about this shipment)",
        disableBeacon: true,
      },
      {
        target: ".TourtwelvethStep",
        content: "Track  shipment on map view real time",
        disableBeacon: true,
      },
      {
        target: ".TourthirteenthStep",
        content:
          "Shipment that has arrived! (Click here to filter by shipments that have arrived)",
        disableBeacon: true,
      },
      {
        target: ".TourfourteenthStep",
        content:
          "View status of cargo based on their milestones (Click to view your cargo’s status by milestones)",
        disableBeacon: true,
      },
      {
        target: ".TourfifteenthStep",
        content:
          "View details of each shipment (View more details about this shipment)",
        disableBeacon: true,
      },
      {
        target: ".ToursixteenthStep",
        content:
          "View, upload, and share documents real time (View, Upload & Share documents in real-time)",
        disableBeacon: true,
      },
      {
        target: ".TourseventeenthStep",
        content:
          "Your clients can also filter the search (Click here to refine your search results)",
        disableBeacon: true,
      },
      {
        title: "Statement of Account",
        target: ".ToureighteenthStep",
        content:
          "Your clients can maintain statement of accounts (Maintain & View Statements of account in one place.)",
        placement: "right",
        disableBeacon: true,
      },
      {
        title: "Dashboard",
        target: ".TournineteenthStep",
        content:
          "A dashboard with analytics for clients for decision making (Click here for all your analytics for better decision making)Filter your search (Further refine your search)",
        placement: "right",
        disableBeacon: true,
      },
      {
        title: "Whatsapp",
        target: ".TourTwentyfirstStep",
        content:
          "Clients can get in touch with their accounts manager via WhatsApp or with API connectivity to an external chatbot (Need further help? Get in touch with an accounts manager! Whatsapp or ChatBot available.)",
        placement: "right",
        disableBeacon: true,
      },
      {
        target: ".TourTwentysecondStep",
        content:
          "Clients can manage users that have access (Click here to manage all your users access rights)",
        placement: "right",
        disableBeacon: true,
      },
      {
        title: "Logo",
        target: ".TourLogo",
        content:
          "Customize to your branding (Your logos and custom brandings go here)",
        placement: "bottom",
        disableBeacon: true,
      },
    ],
    stepIndex: 0,
  });

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    if (data?.step?.screen) {
      history(data?.step?.screen);
    }
    if (action === "close") {
      context.SetRun(false);
    }
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setTourState({
        ...tourState,
        stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
      });
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      context.SetRun(false);
    }
  };

  return (
    <>
      {context.isUserLogin ? (
        <Joyride
          steps={tourState.steps}
          run={context.run}
          stepIndex={tourState.stepIndex}
          continuous
          disableScrolling
          showSkipButton
          callback={handleJoyrideCallback}
          styles={{
            options: {
              arrowColor: "#ffff",
              primaryColor: "#0a2d44",
              textColor: "#0a2d44",
              width: 300,
              zIndex: 1000,
            },
          }}
        />
      ) : null}
      <NotificationContainer />
      <Navigation />
    </>
  );
}

export default App;
